// extracted by mini-css-extract-plugin
export var contrastLow = "_p-1";
export var externalLink = "_p-2";
export var externalLinkIcon = "_p-3";
export var link = "_p-0";
export var linkLabel = "_p-4";